"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfFacilityAbbrDto = instanceOfFacilityAbbrDto;
exports.FacilityAbbrDtoFromJSON = FacilityAbbrDtoFromJSON;
exports.FacilityAbbrDtoFromJSONTyped = FacilityAbbrDtoFromJSONTyped;
exports.FacilityAbbrDtoToJSON = FacilityAbbrDtoToJSON;
exports.FacilityAbbrDtoToJSONTyped = FacilityAbbrDtoToJSONTyped;
/**
 * Check if a given object implements the FacilityAbbrDto interface.
 */
function instanceOfFacilityAbbrDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function FacilityAbbrDtoFromJSON(json) {
    return FacilityAbbrDtoFromJSONTyped(json, false);
}
function FacilityAbbrDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'name': json['name'],
    };
}
function FacilityAbbrDtoToJSON(json) {
    return FacilityAbbrDtoToJSONTyped(json, false);
}
function FacilityAbbrDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'name': value['name'],
    };
}
//# sourceMappingURL=FacilityAbbrDto.js.map